// assets/js/pages/revenue-calculator/main.js
const $ = require("jquery");
const { initRevenueCalculator } = require("../../components/revenue-calculator/index");

$(function () {
    document.querySelectorAll("[data-rc-calculator]").forEach(function (el) {
        initRevenueCalculator(el);
    });

    // Dev-only visual QA harness: /en/revenue-calculator?rc_kitchen_sink=1
    // renders every step/branch on one page. See kitchen-sink.js.
    // Dynamic import keeps the harness in its own chunk, so production visitors never download it.
    if (window.location.search.indexOf("rc_kitchen_sink=1") !== -1) {
        import(/* webpackChunkName: "rc-kitchen-sink" */ "./kitchen-sink").then(function (m) { m.renderKitchenSink(); });
    }
});
